import React, { Component } from 'react';
import { Button, Glyphicon } from 'react-bootstrap';

class ButtonBack extends Component {

    onBackClicked() {
        window.history.back();
    }

    render() {
        return (
            <Button type="button" bsStyle="default" onClick={this.onBackClicked.bind(this)}>
                <Glyphicon glyph="chevron-left" />
                <span>Back</span>
            </Button>
        );
    }
}

export default ButtonBack;


// WEBPACK FOOTER //
// ./src/Components/ButtonBack.js